import { Mail, Notifications, LocationOn } from "@mui/icons-material";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { QrCode } from '@mui/icons-material';

import {
    AppBar,
    Avatar,
    Badge,
    Box,
    InputBase,
    Menu,
    MenuItem,
    styled,
    Toolbar,
    Typography,
} from "@mui/material";
import React, { useState } from "react";

import Cart from '../../assets/cart.png'
import DaalchiniLogo from '../../assets/dalchini_icon.png'

import LocationPin from '../../assets/locationPin.png'
import LoctionPinHeader from '../../assets/locat.png'
import QrMarkHeader from '../../assets/qrmark.png'
import { useNavigate } from "react-router-dom";

const StyledToolbar = styled(Toolbar)({
    display: "flex",
    justifyContent: "space-between",


});


const Search = styled("div")(({ theme }) => ({
    backgroundColor: "white",
    padding: "0 10px",
    borderRadius: theme.shape.borderRadius,
    width: "40%",
}));

const Icons = styled(Box)(({ theme }) => ({
    display: "none",
    alignItems: "center",
    gap: "20px",
    [theme.breakpoints.up("sm")]: {
        display: "flex",
    },
}));

const UserBox = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    [theme.breakpoints.up("sm")]: {
        display: "none",
    },
}));
const TopNavbar = ({ShowQRFun,shareLocation,preCart}) => {
  const navigate=useNavigate()
    const [open, setOpen] = useState(false);
     const totalCount =preCart&& preCart[0]&&preCart.reduce((total, item) => total + item.count, 0);

    //console.log("preCart",preCart)
    const [openLocationModal, setOpenLocationModal] = useState(false);
    const handleShowQr=()=>{
        //console.log("handleShowQr")

        ShowQRFun()
    }
    const goMyCart = () => {
    localStorage.setItem("mycart", true);
 /*    mpCartClicked({
      EventName: mixpanelEvent,
      data: { ItemsInCart: cartItemsList, TotalCartValue: totalAmount },
    }); */
    navigate("/myCart");
  };



    const handleOpen = () => {
        setOpenLocationModal(true);
    };

    const handleClose = () => {
        shareLocation()
        setOpenLocationModal(false);
    };


const LocationModal = () => {
  return (
    <Dialog
      open={openLocationModal}
      onClose={handleClose}
      fullWidth
     
      PaperProps={{
        sx: {
          overflow: "visible", // ✅ allow floating image to show
          borderRadius: 3,
          p: 3,
          position: "relative",
           maxWidth:"300px"
        },
      }}
    >
      {/* Floating Image */}
      <Box
        sx={{
          position: "absolute",
          top: -40, // half outside
          left: "50%",
          transform: "translateX(-50%)",
          width: 80,
          height: 80,
          zIndex: 1,
        }}
      >
        <img
          src={LocationPin}
          alt="Location Icon"
          style={{ width: "100%", height: "100%" }}
        />
      </Box>

      {/* Content */}
      <Box sx={{ textAlign: "center", mt: 5 }}> {/* mt pushes content below floating image */}
        <Typography
          variant="h6"
          fontWeight={700}
          fontFamily="Roboto"
          color="rgb(56, 79, 111)"
          letterSpacing="0.5px"
          lineHeight={1.5}
        >
          Find Nearby Vending Machines
        </Typography>

        <Typography
          variant="body2"
          fontWeight={400}
          fontFamily="Roboto"
          color="rgba(56, 79, 111, 0.7)"
          letterSpacing="0.5px"
          lineHeight={1.4}
          sx={{ mt: 2, px: 3 }}
        >
          Share your current location to find the nearest options
        </Typography>

        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            backgroundColor: "rgb(0, 177, 119)",
            width: "100%",
            mt: 4,
            py: 1.5,
            fontWeight: 800,
            borderRadius: 2,
            textTransform: "none",
            "&:hover": { backgroundColor: "rgb(0, 160, 110)" },
          }}
        >
          Share
        </Button>
      </Box>
    </Dialog>
  );
};



    return (
   
        <AppBar position="sticky" style={{ backgroundColor: "#fae14b", boxShadow: "none" }}>
        <LocationModal/>
            <StyledToolbar >
                <Toolbar style={{ overflowY: "none" }} >
                    <img
                        src={DaalchiniLogo}  // Replace with the actual path to your logo image
                        alt="Logo"
                        style={{ maxHeight: 30, marginRight: 10 }}
                    />
                </Toolbar>

                <Search sx={{ display: { xs: "none", sm: "none",md:"block" } }} >
                    <InputBase placeholder="search..." />
                </Search>
      
                <Box style={{display:"flex",    alignItems: "center"}}>
                
                  <img
                        src={LoctionPinHeader}  // Replace with the actual path to your logo image
                        alt="LoctionPinHeader"
                        style={{ height: "24px",width:"20px",    marginRight:"12px" }}
                        onClick={handleOpen} 
                    />

                    
                  <Badge
        badgeContent={totalCount}
        color="error"
        overlap="circular"
        sx={{
          "& .MuiBadge-badge": {
            fontSize: "0.7rem",
            height: 18,
            minWidth: 18,
            top: "13px",
            right: "18px",
            backgroundColor: "#129a69",
          },
        }}
      >
        <img
          src={Cart}
          alt="Cart"
          onClick={() => totalCount && goMyCart()}
          style={{
            width: "40px",
            marginRight: "10px",
            cursor: totalCount ? "pointer" : "default",
            //opacity: totalCount ? 1 : 0.6,
          }}
        />
      </Badge> 
                    
               <img
                        src={QrMarkHeader}  // Replace with the actual path to your logo image
                        alt="QrMarkHeader"
                        style={{ height: "26px",width:"26px" }}
                        onClick={(e)=>{handleShowQr(e)}} 
                    />
              
                </Box>


            </StyledToolbar>
        
        </AppBar>
    );
};

export default TopNavbar;